import { ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { AuthService, StorageService } from '@pulpo/pulpo-api';
import { RoleTypeEnum } from '@pulpo/pulpo-models';
import { PulpoSnackbarComponent } from '@pulpo/pulpo-commons';
import { Subscription } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnDestroy {
  loginSubscription!: Subscription;
  isSaving = false;

  constructor(
    private router: Router,
    private authService: AuthService,
    private storageService: StorageService,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnDestroy(): void {
    if (this.loginSubscription) {
      this.loginSubscription.unsubscribe();
    }
  }

  onPasswordSubmit(login: string, password: string): void {
    this.isSaving = true;
    this.cdr.markForCheck();
    this.loginSubscription = this.authService.login(login, password).subscribe({
      next: () => {
        if (this.hasAdminAccess()) {
          this.router.navigate(['/reporting']);
        } else {
          this.authService.logoutLocal();
          this.isSaving = false;
          this.cdr.markForCheck();
          this.showError(
            "Ce compte n'est pas autorisé à accéder à l'administration."
          );
        }
      },
      error: (err) => {
        console.log(err);
        this.isSaving = false;
        this.showError('Identifiants invalides.');
        this.cdr.markForCheck();
      },
    });
  }

  // Mirrors AdminAuthGuard: admin access is granted to the TECHNICAL_ADMIN role.
  private hasAdminAccess(): boolean {
    return (
      this.storageService.getSessionRoleType() === RoleTypeEnum.TECHNICAL_ADMIN
    );
  }

  private showError(message: string): void {
    this.snackBar.openFromComponent(PulpoSnackbarComponent, {
      data: {
        title: 'Une erreur est survenue !',
        message,
        backgroundColor: '#ec2b2b',
        accentColor: 'white',
      },
      duration: 3000,
      panelClass: ['snackbar'],
    });
  }
}
